import styled from 'styled-components';
export const StyledStatisticsDataComponent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  color: ${(props) => (props.theme.id === 'dark' ? props.theme.text1 : props.theme.text2)};
`;
